export default "__VITE_ASSET__D00vV3_x__"